import "./App.css";
import { BrowserRouter as Router } from "react-router-dom";
import AppRoutes from "./routes";
import { useEffect } from "react";
import mainStore from "./store/store";
import analytics, { initAnalytics } from "./utils/analytics";
import { setupPerformanceMonitoring, preloadCriticalResources } from "./utils/performanceUtils";
import moment from "moment";

import DateTimePicker from "react-datetime-picker";
import "react-datetime-picker/dist/DateTimePicker.css";
import "react-calendar/dist/Calendar.css";
import "react-clock/dist/Clock.css";

function App() {
  const { getAllCars } = mainStore();

  useEffect(() => {
    console.log('🚀 [App] Initializing application...');
    
    getAllCars(moment().format("YYYY-MM-DD"), moment().format("YYYY-MM-DD"));
    
    // Initialize analytics tracking
    console.log('📊 [App] Initializing analytics...');
    initAnalytics();
    console.log('✅ [App] Analytics initialized');
    
    // Initialize performance monitoring
    console.log('⚡ [App] Initializing performance monitoring...');
    setupPerformanceMonitoring();
    
    // Preload critical resources
    preloadCriticalResources([
      { href: '/img/tak8-logo.png', as: 'image' },
      { href: '/css/bootstrap.min.css', as: 'style' },
      { href: '/css/custom.css', as: 'style' }
    ]);
    console.log('✅ [App] Performance monitoring initialized');
    
    // Track errors globally
    window.addEventListener('error', (event) => {
      console.error('❌ [App] JavaScript error:', event.message);
      analytics.trackError('javascript_error', event.message, {
        filename: event.filename,
        lineno: event.lineno,
        colno: event.colno
      });
    });
    
    // Track unhandled promise rejections
    window.addEventListener('unhandledrejection', (event) => {
      console.error('❌ [App] Unhandled promise rejection:', event.reason);
      analytics.trackError('unhandled_rejection', event.reason?.message || 'Unknown error', {
        reason: event.reason
      });
    });
    
    console.log('✅ [App] Application initialized successfully');
  }, []);

  return (
    <Router>
      <AppRoutes />
    </Router>
  );
}

export default App;
